import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { ResellerImpersonatePage } from '@/features/reseller/pages/impersonate'

export const Route = createFileRoute('/_authenticated/reseller/impersonate')({
  beforeLoad: requireRole(['reseller']),
  component: ResellerImpersonatePage,
})
